module.exports = __webpack_public_path__ + "static/media/bonheurLogo.94d75661.png";